import { http } from '@/api/client/httpClient';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

// AccountSecurityAppService -> /api/app/account-security/*
export interface AccountSecurityStatusDto {
  twoFactorEnabled: boolean;
  userName: string;
  email: string;
  emailConfirmed: boolean;
}
export interface AuthenticatorSetupDto {
  sharedKey: string;
  authenticatorUri: string;
  qrCodeDataUrl: string;
}
export interface EnableAuthenticatorInput {
  verificationCode: string;
}

const BASE = '/api/app/account-security';

export const accountSecurityApi = {
  getStatus: () => http.get<AccountSecurityStatusDto>(`${BASE}/status`).then((r) => r.data),
  getSetup: () => http.get<AuthenticatorSetupDto>(`${BASE}/authenticator-setup`).then((r) => r.data),
  enable: (input: EnableAuthenticatorInput) => http.post(`${BASE}/enable-authenticator`, input).then((r) => r.data),
  disable: (input: EnableAuthenticatorInput) => http.post(`${BASE}/disable-two-factor`, input).then((r) => r.data),
};

const STATUS_KEY = ['account-security', 'status'] as const;

export function useSecurityStatus() {
  return useQuery({ queryKey: STATUS_KEY, queryFn: accountSecurityApi.getStatus });
}
export function useAuthenticatorSetup(enabled: boolean) {
  return useQuery({ queryKey: ['account-security', 'setup'], queryFn: accountSecurityApi.getSetup, enabled });
}
export function useEnableAuthenticator() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: EnableAuthenticatorInput) => accountSecurityApi.enable(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: STATUS_KEY }),
  });
}
export function useDisableTwoFactor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: EnableAuthenticatorInput) => accountSecurityApi.disable(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: STATUS_KEY }),
  });
}
